import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zManufacturerSchemaDom, zManufacturerSchemaCreateDom, } from "@/types/manufacturer/manufacturer.domain";
import { zManufacturerSchemaCreateDto, zManufacturerSchemaDto, } from "@/types/manufacturer/manufacturer.dto";
/**
 * Маппер для Manufacturer: DTO <-> Domain (1:1).
 */
export const ManufacturerMapper = makeSimpleMapper({
    dtoToDomain: (dto) => zManufacturerSchemaDom.parse(dto),
    domainToDto: (domain) => zManufacturerSchemaDto.parse(domain),
    dtoToCreateDto: (domain) => zManufacturerSchemaCreateDto.parse(domain),
    dtoToCreateDom: (dto) => zManufacturerSchemaCreateDom.parse(dto),
});
